import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-virtual-keyboard',
  template: `
<span tabindex="1" class="input-group-prepend ingroup" (click)="setShow($event)">
    <span class="input-group-text" >
        <i class="fa fa-keyboard-o"></i>
    </span>
</span>
<div class="vk-light-box" *ngIf="isShow" [ngClass]="position" id="virtual_keyboard_{{id}}" (focusout)="test($event)">
  <div class="modal-box no-padding" >
    <div >              
      <i class="ico fa fa-times-circle faa-red cursor-pointer i-close" aria-hidden="true" (click)="closePopUpFunc()"></i>              
    </div>

    <div class="modal-body" class="text-ltr">
        <div class="row" style="margin-left: 22px;">
          <input type="button" class="kbtn key" *ngFor="let k of line1" value="{{k}}" (click)="keyClicked(k)" />
        </div>
        <div class="row">
          <input type="button" class="kbtn key" *ngFor="let k of line2" value="{{k}}" (click)="keyClicked(k)" />
        </div>
        <div class="row">
            <input type="button" class="kbtn key" *ngFor="let k of line3" value="{{k}}" (click)="keyClicked(k)" />
        </div>
        <div class="row" style="margin-left: 28px;">
            <input type="button" class="key" style="width: 150px" value=" " (click)="keyClicked(' ')" />
            <!--button class="kbtn key" (click)="keyClicked('-')">-</button-->
            <input type="button" class="key" (click)="keyClicked('')" value="<=" />
        </div>
    </div>
  </div>
  `,
  styles: [`
  @media print {
    .vk-light-box {
      position: relative;
      margin-top: 10px;
      left: 0;
      //width: 100%;
      height: 100%;
      z-index: 100;
      page-break-before: always;
      visibility: visible !important;
      overflow: visible !important;
    }
  
    .form-group {
      page-break-inside: avoid;
    }
  }
  
  @media screen {
    .vk-light-box {
        position: absolute;
        top: 38px;
        right: 40px;
        height: 100%;
        z-index: 100;
    }

    .vk-light-box.top {
      top: -150px;
    }
  }

  /* Medium devices (tablets, less than 992px) */
  /* Large devices (desktops, less than 1200px) */
  @media only screen and (min-width: 768px) { 
    .vk-light-box.left {
      left: -270px;
    }
  }

  /* Small devices (landscape phones, less than 768px) */
  @media only screen and (max-width: 767px) { 
    .vk-light-box.left {
      left: 0;
    }
  }

  .ico {
    position: absolute;
    top: 0;
  }

  .ingroup {
    height: 38px;
    border-radius: 4px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border: 1px solid #285c7e;
  }

  .modal-box {
      display: block;
      position: absolute;
      top: 10%;
      left: 22%;
      height: auto;
      width: 270px;
      max-height: 900px;
      background: rgba(0,123,255,.25);
      border-radius: 8px;
      padding: 15px;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }
  .key {
    border-radius: 4px;
    border: 1px solid #285c7e;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }
  .kbtn {
    width: 25px;
  }
  .row {
    margin-left: 10px;
    margin-right: 10px;
  }
  .no-padding {
      padding-left: 0;
      padding-right: 0;
  }  
  `
  ]
})

export class VirtualKeyboardComponent{
  @Input() control: FormControl;
  @Input() isShow: boolean = false;
  @Input() position = "";
  @Input() id = "";
  @Output() closed = new EventEmitter<string>();
  @Output() keyup = new EventEmitter<KeyboardEvent>();
  
  line1 = ['\'','ק',"ר","א","ט","ו","ן","ם","פ"];
  line2 = ["ש","ד","ג","כ","ע","י","ח","ל","ך","ף"];
  line3 = ["ז","ס","ב","ה","נ","מ","צ","ת","ץ"];

  closePopUpFunc() {
    let list = document.getElementsByClassName("vk-light-box");
    for (let i=0; i < list.length; i++) {
      let lb = (list[i] as HTMLElement);
      lb.hidden = true;
    }
    this.closed.emit();
  }

  setFocusOnFirstKey() {
    let lb = document.getElementById("virtual_keyboard_" + this.id);
    if (!lb || lb.hidden) 
      return;
      
    for (var i = 0; i < lb.childNodes.length; i++) {
      let element = lb.childNodes[i] as HTMLElement;
      if ((element.className && element.className.indexOf("modal-box") >= 0) && (element.childNodes.length > 1))
      {
        element = element.childNodes[1] as HTMLElement;
        while (element && element.childNodes.length > 0)
        {
          element = element.childNodes[0] as HTMLElement;
          if (element.tagName == 'INPUT')
          {
            element.focus();
            return;
          }
        }
      }        
    }
  }
    
  setShow(event) {
    var target = event.target || event.srcElement || event.currentTarget;
    var parent = target.parentNode;

    while (parent.tagName.toLowerCase() != "app-virtual-keyboard") 
      parent = parent.parentNode;

    for (var i = 0; i < parent.childNodes.length; i++) {
      if (parent.childNodes[i].className?.indexOf("vk-light-box") >= 0) { //vk is opened
        let lb = parent.childNodes[i];
        if (lb.hidden == false)
        {
          lb.hidden = true;
          parent.parentNode.childNodes.array.forEach(element => {
            if (element.tagName?.toLowerCase() == "input") 
              element.focus();
          });             
        }
        else {
          lb.hidden = false;
        }        
        return;
      }        
    }     
    
    this.isShow = true;
    setTimeout(() => {
      this.setFocusOnFirstKey();
    }, 100);     
  }

  keyClicked(key) {
    let val_len = this.control.value.length;
    let event;
    let k = (key == "") ? "Delete" : key;
    if (typeof(KeyboardEvent) === 'function') {
      event = new KeyboardEvent('keyup', {key: k,
                      bubbles : true, cancelable : false, shiftKey : false
                });
    } else {    //for IE
      event = document.createEvent('KeyboardEvent');
      event.initKeyboardEvent("keyup",       // typeArg,                                                           
        true,             // canBubbleArg,                                                        
        true,             // cancelableArg,                                                       
        null,             // viewArg,  Specifies UIEvent.view. This value may be null.     
        false,            // ctrlKeyArg,                                                               
        false,            // altKeyArg,                                                        
        false,            // shiftKeyArg,                                                      
        false,            // metaKeyArg,                                                       
        k,               // keyCodeArg,                                                      
        k);   
      event.keyCodeVal = k;
    }

    if (key == '') {
      if (val_len > 0) 
        this.control.setValue( this.control.value.substring(0, val_len-1));
      this.keyup.emit(event);
        
    } else {
      this.keyup.emit(event);     

      let oldvalue = this.control.value;
      this.control.setValue(oldvalue + key);
      if (this.control.errors && this.control.errors.maxlength)
        this.control.setValue(oldvalue);
    }        
  }

  test(event) {
    if (event.relatedTarget && 
        event.relatedTarget.parentElement.parentElement.parentElement.parentElement != event.currentTarget)
    {
      this.closePopUpFunc();
    }
  }
}
